import { Porta } from './../../../../../models/porta';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "app/models/app-filter.model";
import { PortaDivisaoArea } from "../../porta/models/porta-divisao-area";
import { AbPortaDivisaArea } from 'app/abstract/full-pages/equipamento/porta-divisa-area.abstract';

@Injectable({ providedIn: 'root' })
export class PortaDivisaoAreaService extends AbPortaDivisaArea {
    prefixo = "porta";
    //
    perfilSelecionado: any;

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete(`${this.prefixo}/`, id);
    }

    public getAllPortas(filter: AppFilter) {
        return this.get(`${this.prefixo}/filter/${filter.encode()}`);
    }

    public getAllZonas(zonaId: number) {
        return this.get(`${this.prefixo}/all/`, zonaId);
    }

    public getPorta(id: number) {
        return this.get(`${this.prefixo}/`, id);
    }

    public savePorta(porta: Porta): Observable<Porta> {
        return this.save(`${this.prefixo}/`, porta);
    }

    public ListByDivisao(divisaoId: number) {
        return this.get('portas_divisoes_areas/divisoes/', divisaoId).toPromise();
    }

    public getIdentificacaoPerfil(id: number, tipo: string) {
        return this.get(`portas_divisoes_areas/perfil/${id}/${tipo}`);
    }

    public ListByArea(areaId: number) {
        return this.get(`portas_divisoes_areas/areas/${areaId}`).toPromise();
    }

    public savePortaDivisaoArea(pda: PortaDivisaoArea) {
        return this.post('portas_divisoes_areas/create/', pda);
    }

    public getPortas(): Observable<any> {
        return this.get("porta/all");
    }

    public getPerfis(): Observable<any> {
        return this.get("");
    }

}
